import SuccessImage from '../../assets/images/successImage.png'
const SuccessPage = () => {
    return (
        <div className='container'>
            <div className='row d-flex justify-content-center align-items-center' style={{height:'90vh'}}>
                <img src={SuccessImage}  style={{width:'281px'}} height='281px'/>
            </div>
        </div>

    )
}
export default SuccessPage;